<template>
  <div>
    <transition
      :name="animations.fadeIn.name"
      :leave-active-class="animations.fadeIn.leave"
      :enter-active-class="animations.fadeIn.enter"
      mode="out-in"
    >
      <div class="mode_icon" v-if="mode == 'icon' && ready.bauprojekte && ready.hauser && ready.wohnungen && ready.kunden && ready.dienstleister">
        <feather type="info" @click="openModal"></feather>
      </div>
    </transition>
    <div class="mode_widget" v-if="mode == 'widget'">
      <div>
        This is the sendBoardMessage Widget.
      </div>
    </div>
    <b-modal id="sendBoardMessage" @cancel="closeModal" size="lg">
      <div class="container-fluid">
        <!--Modal Step One - Select Recipients -->
        <div id="modalStepOne" v-if="modalStep == 0">
          <transition :name="animations.fadeIn.name" :enter-active-class="animations.fadeIn.enter" :leave-active-class="animations.fadeIn.leave">
            <div id="backButton" class="infra-blue" v-if="tableStep > 0" @click="goBack">
              <feather type="arrow-left" class="infra-blue pointer" size="30"></feather>
            </div>
          </transition>
          <b-tabs>
            <!-- Tab Bauprojekte -->
            <b-tab title="Bauprojekte" :active="activeTab == 0">
              <div class="table-responsive datatable-vue" v-if="tableStep == 0">
                <b-table
                  show-empty
                  :items="bauprojekte"
                  :fields="tablefields.bauprojekte"
                  :filter="filter.bauprojekte"
                  :current-page="currentPage.bauprojekte"
                  :per-page="perPage.bauprojekte"
                  @filtered="filteredBauprojekte"
                >
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'bauprojekt', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'bauprojekt', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                  <template v-slot:cell(goHouses)="row">
                    <transition
                      :name="animations.standard.name"
                      :enter-active-class="animations.standard.enter"
                      :leave-active-class="animations.standard.leave"
                      mode="out-in"
                    >
                      <feather
                        v-if="!isSelected({ context: 'bauprojekt', id: row.item.id, name: row.item.name })"
                        type="arrow-right"
                        class="pointer infra-blue"
                        size="25"
                        @click="goHouses(row.item)"
                        :key="row.item.id + 'arrowbp'"
                      ></feather>
                      <feather v-else type="check" class="green" size="25" :key="row.item.id + 'checkbp'"></feather>
                    </transition>
                  </template>
                  <template slot="empty"> <div class="text-center">Keine Bauprojekte gefunden.</div></template>
                </b-table>
              </div>
              <!-- table hauser -->
              <div class="table-responsive datatable-vue" v-if="tableStep == 1">
                <b-table
                  show-empty
                  :items="tableSelected.bp.extended.hauser"
                  :fields="tablefields.hauser"
                  :filter="filter.hauser"
                  :current-page="currentPage.hauser"
                  :per-page="perPage.hauser"
                  @filtered="filteredHauser"
                >
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'haus', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'haus', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                  <template v-slot:cell(goWohnungen)="row">
                    <transition
                      :name="animations.standard.name"
                      :enter-active-class="animations.standard.enter"
                      :leave-active-class="animations.standard.leave"
                      mode="out-in"
                    >
                      <feather
                        v-if="!isSelected({ context: 'haus', id: row.item.id, name: row.item.name })"
                        type="arrow-right"
                        class="pointer infra-blue"
                        size="25"
                        @click="goWohnungen(row.item)"
                        :key="row.item.id + 'arrowHouse'"
                      ></feather>
                      <feather v-else type="check" class="green" size="25" :key="row.item.id + 'checkhouse'"></feather>
                    </transition>
                  </template>
                  <template slot="empty"><div class="text-center">Keine Häuser gefunden.</div></template>
                </b-table>
              </div>
              <!-- table wohnungen -->
              <div class="table-responsive datatable-vue" v-if="tableStep == 2">
                <b-table
                  show-empty
                  :items="tableSelected.haus.extended.wohnungen"
                  :fields="tablefields.wohnungen"
                  :filter="filter.wohnungen"
                  :current-page="currentPage.wohnungen"
                  :per-page="perPage.wohnungen"
                  @filtered="filteredWohnungen"
                >
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'wohnung', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'wohnung', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                  <template v-slot:cell(wohnflaeche)="row"> {{ row.item.wohnflaeche }} m<sup>2</sup> </template>
                  <template slot="empty"><div class="text-center">Keine Wohnungen gefunden.</div></template>
                </b-table>
              </div>
            </b-tab>
            <!-- Tab Kunden -->
            <b-tab title="Kunden" :active="activeTab == 1">
              <b-row>
                <b-col md="12" class="list_mode iam-table-ux" style="margin-top:20px;margin-bottom:20px;">
                  <b-input-group class="datatable-btn">
                    <div>
                      <b-form-input style="border:1px solid lightgrey" v-model="filter.kunden" placeholder="Suchen"></b-form-input>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- table kunden -->
              <div class="table-responsive datatable-vue">
                <b-table
                  show-empty
                  :items="kunden"
                  :fields="tablefields.kunden"
                  :current-page="currentPage.kunden"
                  :per-page="perPage.kunden"
                  :filter="filter.kunden"
                  @filtered="filteredKunden"
                >
                  <template v-slot:cell(name)="row"> {{ row.item.first_name }} {{ row.item.last_name }} </template>
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'kunde', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'kunde', id: row.item.id, name: kundeName(row.item) })"
                      />
                    </div>
                  </template>
                  <template slot="empty">
                    <div class="text-center">Keine Kunden gefunden.</div>
                  </template>
                </b-table>
              </div>
              <b-col md="6" class="my-1">
                <b-pagination
                  v-if="totalRows.kunden > perPage.kunden"
                  v-model="currentPage.kunden"
                  :total-rows="totalRows.kunden"
                  :per-page="perPage.kunden"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-tab>
            <!-- Tab Dienstleister -->
            <b-tab title="Dienstleister" :active="activeTab == 2">
              <b-row>
                <b-col md="12" class="list_mode iam-table-ux" style="margin-top:20px;margin-bottom:20px;">
                  <b-input-group class="datatable-btn">
                    <div>
                      <b-form-input style="border:1px solid lightgrey" v-model="filter.dienstleister" placeholder="Suchen"></b-form-input>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- Table Dienstleister -->
              <div class="table-responsive datatable-vue">
                <b-table
                  show-empty
                  :items="dienstleister"
                  :fields="tablefields.dienstleister"
                  :current-page="currentPage.dienstleister"
                  :per-page="perPage.dienstleister"
                  :filter="filter.dienstleister"
                  @filtered="filteredDienstleister"
                >
                  <template v-slot:cell(name)="row"> {{ row.item.name }}</template>
                  <template v-slot:cell(auswahl)="row">
                    <div>
                      <input
                        type="checkbox"
                        :checked="isSelected({ context: 'dienstleister', id: row.item.id, name: row.item.name })"
                        @click="handleSelect({ context: 'dienstleister', id: row.item.id, name: row.item.name })"
                      />
                    </div>
                  </template>
                  <template slot="empty"><div class="text-center">Keine Dienstleister gefunden.</div></template>
                </b-table>
              </div>
              <b-col md="6" class="my-1">
                <b-pagination
                v-if="totalRows.dienstleister > perPage.diensleister"
                  v-model="currentPage.dienstleister"
                  :total-rows="totalRows.dienstleister"
                  :per-page="perPage.dienstleister"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-tab>
          </b-tabs>
        </div>
        <!-- Modal Step 2 -->
        <div id="modalStepTwo" v-if="modalStep == 1">
          <div class="row">
            <div class="col-12">
              <div class="form-container">
                <label>Titel</label>
                <b-input-group prepend="Abc" class="form-input-group">
                  <b-input v-model="msg.title"></b-input>
                </b-input-group>
                <label>Nachricht</label>
                <vue-editor v-model="msg.body" :editorToolbar="editorOptions"></vue-editor>
                <b-input-group class="multi-input-row form-input-group">
                  <div style="display:flex;">
                    <label style="position:relative; top:10px;">Priorität</label>
                    <b-form-select v-model="msg.priority" :options="msgPrios"> </b-form-select>
                  </div>
                  <div style="display:flex;">
                    <label style="position:relative; top:10px;margin-left:20px;">per Mail</label>
                    <input style="position:relative; top:12px;margin-left:10px;" type="checkbox" v-model="msg.per_mail" />
                  </div>
                </b-input-group>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal Step 3 -->
        <div id="modalStepThree" v-if="modalStep == 2">
          <div>
            <div class="sendMessageBoardPreview">
              <div class="card-body">
                <h4 style="margin-top:20px; margin-bottom:20px;">Nachrichtenvorschau</h4>
                <div class="card" style="margin-top:20px">
                  <div class="card-header">
                    <div class="msg_preview_header">
                      <div class="msg_preview_title">
                        <h5 v-html="msg.title">{{ msg.title }}</h5>
                      </div>
                      <div class="preview_indicators">
                        <div class="preview_mail_icon">
                          <feather
                            class="infra-blue"
                            type="mail"
                            size="25"
                            id="send_mail_icon"
                            v-if="msg.per_mail"
                            style="position:relative;top:7px;"
                          ></feather>
                          <b-tooltip v-if="msg.per_mail" target="send_mail_icon" triggers="hover" placement="left"
                            >Meldung wird auch per Mail versandt</b-tooltip
                          >
                        </div>
                        <div class="preview_badges">
                          <span class="badge badge-info" v-if="msg.priority == 'niedrig'">Information</span>
                          <span class="badge badge-success" v-if="msg.priority == 'normal'">Meldung</span>
                          <span class="badge badge-warning" v-if="msg.priority == 'hoch'">Wichtig</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body" v-html="msg.body"></div>
                </div>
                <div class="accordion" role="tablist">
                  <b-card no-body class="mb-1">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                      <b-button block v-b-toggle.acc_recipients variant="info">{{ amountAllRecipients }} Empfänger</b-button>
                    </b-card-header>
                    <b-collapse id="acc_recipients" accordion="recipients-accordion" role="tabpanel">
                      <b-card-body>
                        <div class="table-responsive datatable-vue">
                          <b-table
                            :items="selected"
                            :fields="tablefields.recipients"
                            :current-page="currentPage.recipients"
                            :per-page="perPage.recipients"
                            @filtered="filteredRecipients"
                          >
                            <template v-slot:cell(context)="row">
                              {{ ucFirst(row.item.context) }}
                            </template>
                            <template v-slot:cell(amount_recipients)="row">
                              {{ computeAmountRecipients(row.item) }}
                            </template>
                          </b-table>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Header Pearls -->
      <template slot="modal-header">
        <!-- Step 1 -->
        <div
          class="u-pearl col-4 progress_pearl"
          :class="{ current: modalStep == 0, done: modalStep == 1 || modalStep == 2 }"
          id="msgStepOne"
          ref="msgStepOne"
        >
          <span class="u-pearl-number">1</span>
          <span class="u-pearl-title">Empfänger wählen</span>
        </div>
        <!-- Step 2 -->
        <div class="u-pearl col-4 progress_pearl" :class="{ current: modalStep == 1, done: modalStep == 2 }" id="msgStepTwo" ref="msgStepTwo">
          <span class="u-pearl-number">2</span>
          <span class="u-pearl-title">Nachricht verfassen</span>
        </div>
        <!-- Step 3 -->
        <div class="u-pearl col-4 progress_pearl" :class="{ current: modalStep == 2 }" id="msgStepOne" ref="msgStepOne">
          <span class="u-pearl-number">3</span>
          <span class="u-pearl-title">Prüfen</span>
        </div>
      </template>
      <template v-slot:modal-footer>
        <Loader v-if="sending" size="35" style="position:relative;bottom:none;top:none;display:inline-block;height:auto;width:auto;" />
        <b-button class="btn btn-warning" @click="closeModal">Abbrechen</b-button>
        <b-button v-if="modalStep == 0" :disabled="!selected.length" @click="computeAmountAllRecipients">Nachricht verfassen</b-button>
        <b-button v-if="modalStep == 1" :disabled="!msg.title.length || !msg.body.length" @click="modalStep = 2">fertigstellen</b-button>
        <b-button v-if="modalStep == 2" @click="dispatchMessage">Absenden</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader.vue";
import { VueEditor } from "vue2-editor";

export default {
  name: "sendBoardMessage",
  props: ["mode"],
  components: {
    Loader,
    VueEditor,
  },
  data() {
    return {
      sending: false,
      selected: [],
      modalStep: 0,
      tableStep: 0,
      activeTab: 0,
      amountAllRecipients: 0,
      tableSelected: {
        bp: false,
        haus: false,
      },
      tablefields: {
        kunden: [
          { key: "name", label: "Name", sortable: true },
          { key: "email", label: "Email", sortable: true },
          { key: "telefon", label: "Telefon", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: true },
        ],
        bauprojekte: [
          { key: "name", label: "Bauprojekt", sortable: true },
          { key: "extended.hauser.length", label: "Häuser", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: false },
          { key: "goHouses", label: "zu Häusern", sortable: false },
        ],
        hauser: [
          { key: "name", label: "Haus", sortable: true },
          { key: "extended.wohnungen.length", label: "Wohnungen", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: false },
          { key: "goWohnungen", label: "zu Wohnungen", sortable: false },
        ],
        wohnungen: [
          { key: "name", label: "Wohnung", sortable: true },
          { key: "wohnflaeche", label: "Wohnfläche", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: true },
        ],
        dienstleister: [
          { key: "name", label: "Firma", sortable: false },
          { key: "extended.branchenString", label: "Branchen", sortable: true },
          { key: "auswahl", label: "Auswahl", sortable: false },
        ],
        recipients: [
          { key: "context", label: "Typ", sortable: true },
          { key: "name", label: "Name", sortable: true },
          { key: "amount_recipients", label: "Anzahl Empfänger", sortable: true },
        ],
      },
      filter: {
        kunden: null,
        bauprojekte: null,
        hauser: null,
        wohnungen: null,
        dienstleister: null,
        recipients: null,
      },
      totalRows: {
        kunden: 1,
        bauprojekte: 1,
        hauser: 1,
        wohnungen: 1,
        diensleister: 1,
        recipients: 1,
      },
      currentPage: {
        kunden: 1,
        bauprojekte: 1,
        hauser: 1,
        wohnungen: 1,
        diensleister: 1,
        recipients: 1,
      },
      perPage: {
        kunden: 10,
        bauprojekte: 10,
        hauser: 10,
        wohnunen: 10,
        dienstleister: 10,
        recipients: 10,
      },
      pageOptions: {
        kunden: [10, 50, 100],
        bauprojekte: [10, 20, 50],
        hauser: [10, 50, 100],
        wohnungen: [10, 50, 100],
        dienstleister: [10, 50, 100],
      },
      msg: {
        title: "",
        body: "",
        priority: "normal",
        recipients: [],
        per_mail: false,
        status: "active",
      },
      msgDefault: {
        title: "",
        body: "",
        priority: "normal",
        recipients: [],
        per_mail: false,
        status: "active",
      },
      msgPrios: ["hoch", "normal", "niedrig"],
      relation: {
        kunde_wohnung: [],
        bauprojekt_dienstleister: [],
        haus_dienstleister: [],
        wohnung_dienstleister: [],
      },
    };
  },

  computed: {
    ...mapGetters({
      messages: "msg/messages",
      ready: "app/readyState",
      bauprojekte: "app/bauprojekte",
      kunden: "app/kunden",
      animations: "app/animations",
      hauser: "app/hauser",
      wohnungen: "app/wohnungen",
      toasts: "app/toasts",
      dienstleister: "app/dienstleister",
      editorOptions: "app/editorOptions",
    }),
  },
  async created() {
    //get data for all needed relations
    //kunde -> wohnung
    try {
      const response = await this.$store.dispatch("app/getRelationItems", { collection: "kunde_wohnung" });
      this.relation.kunde_wohnung = response.data;
    } catch (error) {
      console.log(error);
      this.$toasted.show("Error getting Relational Data for Kunde > Wohnung", this.toasts.failure);
    }

    //dienstleister -> bauprojekt
    try {
      const response = await this.$store.dispatch("app/getRelationItems", { collection: "bauprojekt_dienstleister " });
      if (response.hasOwnProperty("data") && response.data.length) this.relation.bauprojekt_dienstleister = response.data;
    } catch (error) {
      console.log(error);
      this.$toasted.show("Error getting Relational Data for Dienstleister > Bauprojekt", this.toasts.failure);
    }

    //dienstleister -> haus
    try {
      const response = await this.$store.dispatch("app/getRelationItems", { collection: "haus_dienstleister" });
      if (response.hasOwnProperty("data") && response.data.length) this.relation.haus_dienstleister = response.data;
    } catch (error) {
      console.log(error);
      this.$toasted.show("Error getting Relational Data for Dienstleister > Haus", this.toasts.failure);
    }

    //dienstleister -> wohnung
    try {
      const response = await this.$store.dispatch("app/getRelationItems", { collection: "wohnung_dienstleister" });
      if (response.hasOwnProperty("data") && response.data.length) this.relation.wohnung_dienstleister = response.data;
    } catch (error) {
      console.log(error);
      this.$toasted.show("Error getting Relational Data for Wohnung", this.toasts.failure);
    }

    this.totalRows.kunden = this.kunden.length;
    this.totalRows.dienstleister = this.dienstleister.length;
  },
  methods: {
    async dispatchMessage() {
      this.msg.recipients = this.selected;
      try {
        this.sending = true;
        const response = await this.$store.dispatch("msg/processMessage", this.msg);
        if (this.msg.per_mail) await this.sendPerMail(response.data);
        this.sending = false;
        await this.$store.dispatch("msg/updateAllMessages");
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.$toasted.show(error, this.toasts.failure);
        this.sending = false;
      }
    },
    async sendPerMail(message) {
      const mailRecipients = await this.resolveMailRecipients(message.recipients);

      //send mails to recipients
      for (let idx = 0; idx < mailRecipients.length; idx++) {
        const mailPayload = {
          to: [mailRecipients[idx]],
          subject: "Neue Meldung von infrabau. " + message.title,
          body: this.buildMailBody(message.body),
          type: "text",
        };
        try {
          await this.$store.dispatch("mail/sendMail", mailPayload);
        } catch (error) {
          console.log(error);
          this.$toasted.show("Fehler beim Versand der Email.", this.toasts.failure);
        }
      }
    },
    buildMailBody(mailBody) {
      return mailBody;
    },
    async resolveMailRecipients(recipients) {
      let result = [];
      await this.refreshKuwoRelation();
      await this.refreshDlRelation();
      recipients.forEach((rec) => {
        switch (rec.context) {
          case "bauprojekt":
            result.push(...this.resolveBpRecipient(rec.id));
            break;
          case "haus":
            result.push(...this.resolveHausRecipient(rec.id));
            break;
          case "wohnung":
            result.push(...this.resolveWohnungRecipient(rec.id));
            break;
          case "kunde":
            result.push(...this.resolveKundeRecipient(rec.id));
            break;
          case "dienstleister":
            result.push(...this.resolveDienstleisterRecipient(rec.id));
            break;
        }
      });
      return result;
    },
    async refreshKuwoRelation() {
      try {
        const response = await this.$store.dispatch("app/getRelationItems", { collection: "kunde_wohnung" });
        if (response.hasOwnProperty("data") && response.data.length) this.relation.kunde_wohnung = response.data;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Error getting Relational Data for Kunde > Wohnung", this.toasts.failure);
      }
    },
    async refreshDlRelation() {
      try {
        //dienstleister-> bauprojekte
        const responseBp = await this.$store.dispatch("app/getRelationItems", { collection: "bauprojekt_dienstleister" });
        if (responseBp.hasOwnProperty("data") && responseBp.data.length) this.relation.bauprojekt_dienstleister = responseBp.data;

        //dienstleister -> haus
        const responseHaus = await this.$store.dispatch("app/getRelationItems", { collection: "haus_dienstleister" });
        if (responseBp.hasOwnProperty("data") && responseHaus.data.length) this.relation.bauprojekt_haus = responseHaus.data;

        //diensleister -> wohnung
        const responseWohnung = await this.$store.dispatch("app/getRelationItems", { collection: "wohnung_dienstleister" });
        if (responseWohnung.hasOwnProperty("data") && responseWohnung.data.length) this.relation.wohnung_haus = responseWohnung.data;
      } catch (error) {
        console.log(error);
        this.$toasted.show("Error updating Dienstleister Relations", this.toasts.failure);
      }
    },
    resolveBpRecipient(bpr) {
      let result = [];
      const bpData = this.bauprojekte.find((bp) => bp.id == bpr);

      //resolve kunden of bauprojekt
      if (bpData.hasOwnProperty("extended") && bpData.extended.hasOwnProperty("hauser")) {
        bpData.extended.hauser.forEach((haus) => {
          const res = this.resolveHausRecipient(haus.id);
          if (res) result.push(...res);
        });
      }

      //resolve Dienstleister of Bauprojekt
      const bpDlRelation = this.relation.bauprojekt_dienstleister.filter((rel) => {
        return rel.bauprojekt_id == bpr;
      });

      if (bpDlRelation.length) {
        bpDlRelation.forEach((rel) => {
          const dl = this.dienstleister.find((dl) => dl.id == rel.dienstleister_id);
          if (result.indexOf(dl.email) == -1) result.push(dl.email);
        });
      }

      if (result.length) return result;
      return [];
    },
    resolveHausRecipient(hausId) {
      let result = [];
      const haus = this.hauser.find((h) => h.id == hausId);
      if (haus && haus.hasOwnProperty("extended") && haus.extended.hasOwnProperty("wohnungen")) {
        haus.extended.wohnungen.forEach((woh) => {
          //get all kunden recipients
          const relationKu = this.relation.kunde_wohnung.find((rel) => woh.id == rel.wohnung);
          if (typeof relationKu !== "undefined") result.push(this.kunden.find((ku) => ku.id == relationKu.kunde).email);
        });
      }

      const hausDlRelation = this.relation.haus_dienstleister.filter((rel) => {
        return rel.haus_id == rel.id;
      });

      if (hausDlRelation.length) {
        let result = [];
        hausDlRelation.forEach((rel) => {
          const dl = this.dienstleister.find((dlst) => dlst.id == rel.dienstleister_id);
          if (result.indexOf(dl.email) == -1) result.push(dl.email);
        });
      }

      if (result.length) return result;
      return [];
    },
    resolveWohnungRecipient(wohnungId) {
      let result = [];

      const relationKu = this.relation.kunde_wohnung.find((rel) => wohnungId == rel.wohnung);
      if (typeof relationKu !== "undefined") result.push(this.resolveKundeRecipient(relationKu.kunde).email);

      if (result.length) return result;
      return [];
    },
    resolveKundeRecipient(kundeId) {
      const kunde = this.kunden.find((ku) => ku.id == kundeId);
      console.log(kunde);
      return [kunde.email];
    },
    resolveDienstleisterRecipient(dlId) {
      const dl = this.dienstleister.find((dl) => dlId == dl.id);
      return [dl.email];
    },
    kundeName(kunde) {
      return kunde.first_name + " " + kunde.last_name;
    },
    computeAmountRecipients(item) {
      let result = 0;
      switch (item.context) {
        case "bauprojekt":
          result += this.computeBpRecipients(item.id);
          break;
        case "haus":
          result += this.computeHausRecipients(item.id);
          break;
        case "wohnung":
          result += this.computeWohnungRecipients();
          break;
        case "kunde":
          result += this.computeKundeRecipients();
          break;
        case "dienstleister":
          result += this.computeDienstleisterRecipients();
          break;
      }
      return result;
    },
    computeAmountAllRecipients() {
      this.modalStep = 1;
      let result = 0;
      if (!this.selected.length) return;
      this.selected.forEach((item) => {
        result += this.computeAmountRecipients(item);
      });
      this.amountAllRecipients = result;
    },
    computeBpRecipients(bp_id) {
      let result = 0;
      //add one for the bp itself
      result += 1;
      const bp = this.bauprojekte.find((bp) => bp_id == bp.id);
      if ("undefined" == typeof bp.extended.hauser) return;
      bp.extended.hauser.forEach((haus) => (result += this.computeHausRecipients(haus.id)));
      return result;
    },
    computeHausRecipients(haus_id) {
      let result = 0;
      result += 1;
      const haus = this.hauser.find((haus) => haus.id == haus_id);
      if ("undefined" == typeof haus.extended) return;
      result += haus.extended.wohnungen.length;
      return result;
    },
    computeWohnungRecipients() {
      return 1;
    },
    computeKundeRecipients() {
      return 1;
    },
    computeDienstleisterRecipients() {
      return 1;
    },
    openModal() {
      this.$bvModal.show("sendBoardMessage");
      this.modalOpen = true;
    },
    closeModal() {
      this.$bvModal.hide("sendBoardMessage");
      this.modalOpen = false;
      this.resetModalState();
    },
    isSelected(selection) {
      if (this.selected.find((el) => el.id == selection.id && el.context == selection.context)) return true;
      return false;
    },
    filteredKunden(filteredItems) {
      this.totalRows.kunden = filteredItems.length;
      this.currentPage.kunden = 1;
    },
    filteredBauprojekte(filteredItems) {
      this.totalRows.bauprojekte = filteredItems.length;
      this.currentPage.bauprojekte = 1;
    },
    filteredHauser(filteredItems) {
      this.totalRows.hauser = filteredItems.length;
      this.currentPage.hauser = 1;
    },
    filteredWohnungen(filteredItems) {
      this.totalRows.wohnungen = filteredItems.length;
      this.currentPage.wohnungen = 1;
    },
    filteredRecipients(filteredItems) {
      this.totalRows.recipients = filteredItems.length;
      this.currentPage.recipients = 1;
    },
    filteredDienstleister(filteredItems) {
      this.totalRows.dienstleister = filteredItems.length;
      this.currentPage.dienstleister = 1;
    },
    handleSelect(selected) {
      const idx = this.selected.findIndex((item) => item.id == selected.id && item.context == selected.context);
      if (idx > -1) {
        this.selected.splice(idx, 1);
        return;
      }
      this.selected.push(this.cloneNonReactive(selected));
    },
    goHouses(bp) {
      this.tableSelected.bp = bp;
      this.tableStep = 1;
    },
    goWohnungen(haus) {
      this.tableSelected.haus = haus;
      this.tableStep = 2;
    },
    goBack() {
      switch (this.tableStep) {
        case 2:
          this.tableSelected.haus = false;
          this.tableStep = 1;
          break;
        case 1: {
          this.tableSelected.bp = false;
          this.tableStep = 0;
          break;
        }
      }
    },
    resetModalState() {
      this.msg = Object.assign({}, this.msgDefault);
      this.selected = [];
      this.modalStep = 0;
      this.tableStep = 0;
      this.amountAllRecipients = 0;
    },
  },
};
</script>

<style>
#backButton {
  position: absolute;
  right: 30px;
  top: 15px;
}

.preview_indicators {
  display: flex;
  flex-flow: row;
  align-items: flex-end;
}

.preview_indicators div {
  margin-left: 10px;
}

.msg_preview_header {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
</style>

<style scoped>
.loader {
  backdrop-filter: unset;
  -webkit-backdrop-filter: unset;
  -moz-backdrop-filter: unset;
  background: transparent;
  position: relative !important;
}
</style>
